// Creating a Map to store services with SERVICE_ID as the key
const ServiceMap = new Map([
    [228, { service_pitched: 314, serviceForHL: "TrustSEAL 1 year", deal_amt: 45000 }],
    [354, { service_pitched: 314, serviceForHL: "TrustSEAL 1 year", deal_amt: 45000 }],
    [280, { service_pitched: 326, serviceForHL: "Star", deal_amt: 125000 }],
    [3,   { service_pitched: 314, serviceForHL: "TrustSEAL 1 year", deal_amt: 45000 }],
    [314, { service_pitched: 326, serviceForHL: "Star", deal_amt: 125000 }],
    [318, { service_pitched: 326, serviceForHL: "Star", deal_amt: 125000 }],
    [340, { service_pitched: 326, serviceForHL: "Star", deal_amt: 125000 }],
    [276, { service_pitched: 328, serviceForHL: "Leader", deal_amt: 250000 }],
    [326, { service_pitched: 328, serviceForHL: "Leader", deal_amt: 250000 }],
    [347, { service_pitched: 328, serviceForHL: "Leader", deal_amt: 250000 }],
    [297, { service_pitched: 328, serviceForHL: "Leader", deal_amt: 250000 }],
    [298, { service_pitched: 328, serviceForHL: "Leader", deal_amt: 250000 }],
    [299, { service_pitched: 328, serviceForHL: "Leader", deal_amt: 250000 }],
    [303, { service_pitched: 328, serviceForHL: "Leader", deal_amt: 250000 }],
    [323, { service_pitched: 328, serviceForHL: "Leader", deal_amt: 250000 }],
    [328, { service_pitched: 319, serviceForHL: "Industry Leader", deal_amt: 600000 }],
    [266, { service_pitched: 319, serviceForHL: "Industry Leader", deal_amt: 600000 }],
    [293, { service_pitched: 319, serviceForHL: "Industry Leader", deal_amt: 600000 }],
    [294, { service_pitched: 319, serviceForHL: "Industry Leader", deal_amt: 600000 }],
    [295, { service_pitched: 319, serviceForHL: "Industry Leader", deal_amt: 600000 }],
    [302, { service_pitched: 319, serviceForHL: "Industry Leader", deal_amt: 600000 }],
    [325, { service_pitched: 319, serviceForHL: "Industry Leader", deal_amt: 600000 }],
    [359, { service_pitched: 361, serviceForHL: "Preferred Star", deal_amt: null }],
    [360, { service_pitched: 361, serviceForHL: "Preferred Star", deal_amt: null }],
    [361, { service_pitched: 364, serviceForHL: "Preferred Leader", deal_amt: null }],
    [362, { service_pitched: 364, serviceForHL: "Preferred Leader", deal_amt: null }],
    [363, { service_pitched: 364, serviceForHL: "Preferred Leader", deal_amt: null }],
    [364, { service_pitched: 371, serviceForHL: "Preferred Industry Leader", deal_amt: null }],
    [369, { service_pitched: 371, serviceForHL: "Preferred Industry Leader", deal_amt: null }],
    [371, { service_pitched: 348, serviceForHL: "Category Leader India", deal_amt: 300000 }],
    [351, { service_pitched: 328, serviceForHL: "Leader", deal_amt: 250000 }],
    [352, { service_pitched: 351, serviceForHL: "IndiaMart Verified Exporter - Diamond", deal_amt: 650000 }],
    [349, { service_pitched: 350, serviceForHL: "IndiaMart Verified Exporter - Gold", deal_amt: 270000 }],
    [350, { service_pitched: 352, serviceForHL: "IndiaMart Verified Exporter - Platinum", deal_amt: 500000 }],
    [355, { service_pitched: 349, serviceForHL: "IndiaMart Verified Exporter - Silver", deal_amt: 110000 }],
    [319, { service_pitched: 348, serviceForHL: "Category Leader India", deal_amt: 300000 }],
    [301, { service_pitched: 348, serviceForHL: "Category Leader India", deal_amt: 300000 }],
    [282, { service_pitched: 348, serviceForHL: "Category Leader India", deal_amt: 300000 }],
    [321, { service_pitched: 348, serviceForHL: "Category Leader India", deal_amt: 300000 }],
    [322, { service_pitched: 348, serviceForHL: "Category Leader India", deal_amt: 300000 }],
    [376, { service_pitched: 314, serviceForHL: "TrustSEAL 1 year", deal_amt: 45000 }]
]);

// Exporting the serviceMap for use in other files
export default ServiceMap;